module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-height-100 l-fixed l-top l-right geo",
    class: [{
      'is-loading': _vm.isLoading
    }],
    attrs: {
      "id": "geo"
    }
  }, [_c('div', {
    staticClass: "geo-map-controls-size"
  }, [_c('span', {
    staticClass: "geo-map-grow",
    on: {
      "click": function($event) {
        return _vm.adjustMapSize('grow')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("arrow_drop_down")])]), _vm._v(" "), _c('span', {
    staticClass: "geo-map-shrink",
    on: {
      "click": function($event) {
        return _vm.adjustMapSize()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("arrow_drop_down")])])]), _vm._v(" "), _c('div', {
    staticClass: "l-height-100 map",
    attrs: {
      "id": "map"
    }
  }), _vm._v(" "), _c('LoaderDots')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d37cd7f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Geo.vue
// module id = 427
// module chunks = 1